export default "__VITE_ASSET__Bdd3VAwP__"